/**
 * 5度电 体验馆报名
 */
export function fiveKwhApply() {
    (function(){
        $(function(){
            const fiveKwhApply = $('.five-kwh-apply')
            if (fiveKwhApply.length === 0) {
                return;
            }
            function renderMediaDom(videoSrc, controls, loop) {
                const type= videoSrc.includes('youtube.com') ? 'youtube' : 'mp4'
                let youtube_id = ''
                let youtube_embed = ''

                if (type === "youtube") {
                    youtube_id = window.Jackery.Utils.getYoutubeId(videoSrc)
                    youtube_embed = `https://www.youtube.com/embed/${youtube_id}`;
                }

                let media_dom = ''
                switch (type) {
                    case 'mp4':
                        media_dom = `
                    <video
                        class="jky-video_media"
                        x5-video-player-type="h5-page"
                        webkit-playsinline="playsinline"
                        playsinline="playsinline"
                        autoplay="autoplay"
                        muted="muted"
                        ${controls==='true' ? 'controls="controls"' : ''}
                        preload="metadata"
                        ${loop==='true' ? 'loop' : ''} "&width=1500"
                    >
                        <source src="${videoSrc}" type="video/mp4">
                    </video>
                `
                        break;
                    case 'youtube':
                        media_dom = `
                    <iframe
                        class="jky-video_media jky-media_youtube rounded-24"
                        src="${youtube_embed}?enablejsapi=1&autoplay=1&${loop==='true' ? 'loop=1':''}&playlist=${youtube_id}&mute=1"
                        class="js-youtube global-settings-popup"
                        style="width: 100%;height: 400px"
                        allow="''; encrypted-media"
                        allowfullscreen=""
                    ></iframe>
                `
                    default:
                        break;
                }
                return media_dom
            }
            fiveKwhApply.each(function(){
                const index = $(this).data('index');
                const currentComponent = `.five-kwh-apply-${index}`;
                const currentPlay = $(`${currentComponent} .video-apply-button`);
                $(`${currentComponent} .video-apply-button`).attr("data-ga-params-current_page", window.location.href);

                currentPlay.each(function () {
                    $(this).on('click', function () {
                        const { video, controls, loop } = this.dataset;
                        const popupHtml = renderMediaDom(video, controls, loop);
                        const uniqueId = `header-xvideo-${index}`;
                        ZModle.updateInstance(popupHtml, {
                            id: uniqueId,
                            class: "header__changeLocal"
                        });
                    });
                });

                if (window.innerWidth <= 1024){
                    const currentSwiper =  $(`${currentComponent} .video-apply-box-mb`)

                    const { autoplay, delay, size } = currentSwiper[0].dataset;
                    this.config = {
                        loop: size > 1,
                        autoplay: autoplay === 'true',
                        autoplayDelay: delay,
                    };
                    const self = this
                    new Swiper(currentSwiper[0], {
                        autoplay: this.config.autoplay ? {
                            delay: this.config.autoplayDelay * 1000,
                            disableOnInteraction: false
                        } : false,
                        slidesPerView: 'auto',
                        loop: this.config.loop,
                        navigation: {
                            nextEl: `.five-kwh-apply-${index} .swiper-apply-button-next`,
                            prevEl: `.five-kwh-apply-${index} .swiper-apply-button-prev`
                        }
                    })
                }

            })
        })
    })();
}
